<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
            page-title="Company Reports Listing"
            :directory="$t('datatables')"
            :icon="'grid'"/>

        <button
            type="button"
            class="btn btn-primary btn-with-shadow float-right"
            data-toggle="modal"
            @click="addReport"
        >
          {{ $t("Add Report") }}
        </button>
        <add-report
            v-if="showModal"
            :table-id="tableId"
            @close-modal="closeReportAddModal"
        />
      </div>

    </div>
    <app-table
        :id="tableId"
        :options="options"
        @action="getListAction"
    />
  </div>
</template>

<script>
// import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../Config/ApiUrl";
import {TableHelpers} from "../Demo/Tables/mixins/TableHelpers";
import {axiosGet} from '../../../Helpers/AxiosHelper';
import {COMPANY_REPORTS} from "@/app/Config/ApiUrl";
import AddReport from "@Views/CompanyReports/AddReport";

export default {
  // extends: CoreLibrary,
  name: "CompanyReport",
  mixins: [TableHelpers],
  data() {
    return {
      modalId: "add-report-modal",
      modalTitle: "Add Company Report",
      preloader: false,
      tableId: "company-report",
      filteredData: {
        status: "",
      },
      search: "",
      rowData: {},
      showModal: false,
      options: {
        name: this.$t("tab_filter"),
        url: actions.COMPANY_REPORTS,
        datatableWrapper: false,
        tableShadow: false,
        showHeader: true,
        columns: [
          {
            title: this.$t("title"),
            type: "custom-html",
            key: "title",
            modifier: (value,row) => {
              return `<a href="/admin/company-reports/show/${row.id}" target="_blank" id="${row.id}"  data-attribute="${row.id}" >${value}</a>`;
            },
          },
          {
            title: this.$t("description"),
            type: "custom-html",
            key: "description",
            modifier: (value) => {
              return `<span>${value}</span>`;
            },
          },

        ],
        actions: [
          {
            title: this.$t("view"),
            icon: "eye",
            type: "none",
            component: "app-add-modal",
            modalId: "demo-add-edit-Modal",
          },
          {
            title: this.$t("delete"),
            icon: "delete",
            type: "none",
          },

        ],
        showFilter: false,
        // showSearch: true,
        showCount: true,
        // showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    // this.searchAndSelectFilterOptions();
  },
  methods: {
    addReport() {
      this.showModal = true;
    },
    closeReportAddModal() {
      $("#add-report-modal").modal("hide");
      this.showModal = false;
    },

    getSearchValue(value) {
      let instance = this;
      this.search = value;
      setTimeout(function () {
        instance.$hub.$emit("reload-" + instance.tableId);
      });
    },
    getFilterValue(item) {
      this.filteredData.status = item;

      this.$hub.$emit("reload-" + this.tableId);
    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == this.$t('view')) {
        this.view(rowData.id);
      }
      else if (actionObj.title == this.$t('payment'))
      {
        if (rowData.status == 'succeeded')
        {
          this.$toastr.s('You are already paid customer');
        }
        else
        {
          window.location = '/admin/stripePay2/' + rowData.id;
        }

      }

    },
    view(id) {
      this.$emit("id", id);
    },
    openReportDetail(id){
      let doc = document.getElementById(id);
      if(doc){
        doc.addEventListener('click', () => {
          this.view(doc.dataset.attribute);
        });
      }
    },

  },
  mounted() {

  },
  computed: {
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
  },
};
</script>
